import { area } from '@turf/turf'
import MapboxDraw from '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw'
import BaseTool from '@/components/geoview/tools/BaseTool'
import store from '@/store/index'

class Draw extends BaseTool {
  constructor (mapHelper, data) {
    super(mapHelper, data)
    this.mode = 'select'
    this.selectedFeature = null
    this.selectedFeatureId = null
    this.changeDialog = false
    this.draw = new MapboxDraw({
      displayControlsDefault: false,
      controls: {
        polygon: false,
        trash: false
      },
      defaultMode: 'simple_select'
    })

    this.getMap().addControl(this.draw)

    // this.getMap().on('draw.create', this.drawCreate)
    this.getMap().on('draw.update', this.drawUpdate)
    // this.getMap().on('draw.delete', this.drawDelete)
    // this.getMap().on('draw.modechange', this.drawModeChange)
  }

  async onClick (e) {
    if (this.draw.getMode() !== 'simple_select') {
      return
    }
    let layerNames = []
    for (let layerId in this.mapHelper.layers) {
      if (!this.mapHelper.layers.hasOwnProperty(layerId)) {
        return
      }
      layerNames.push(this.mapHelper.layers[layerId].getLayerId())
    }
    let f = this.getMap().queryRenderedFeatures(e.point, { layers: layerNames })

    if (f.length === 0) {
      if (this.selectedFeatureId) {
        this.draw.changeMode('direct_select', { featureId: this.selectedFeatureId })
      }
      return
    }

    let newFeature = f[0]

    // get layer data
    if (newFeature.layer.id) {
      let layerId = Number(newFeature.layer.id.replace('Layer', ''))
      let selectedLayer = store.getters['layer/get'](layerId)
      if (!selectedLayer.vectorEditable) {
        if (this.selectedFeatureId) {
          this.draw.changeMode('direct_select', { featureId: this.selectedFeatureId })
        }
        return this.mapHelper.onToolError('Layer ist für die Vektorbearbeitung gesperrt.')
      }
    }

    if (this.changeDialog) {
      let result = await this.showChangeDialog()
      if (!result) {
        if (this.selectedFeatureId) {
          this.draw.changeMode('direct_select', { featureId: this.selectedFeatureId })
        }
        return
      }
      this.changeDialog = false
    }

    if (this.selectedFeature) {
      // deselect old feature --> @todo: abfrage hinzufügen ob gewollt?
      this.getMap().setFeatureState({ source: this.selectedFeature.source, id: this.selectedFeature.id }, { disabled: false })
    }

    this.selectedFeature = newFeature
    let poly = JSON.parse(this.selectedFeature.properties.polygon)
    this.updateToolInfo(poly)
    this.draw.deleteAll()
    let featureIds = this.draw.add(poly)
    this.selectedFeatureId = featureIds[0]
    this.draw.changeMode('direct_select', { featureId: this.selectedFeatureId })
    // now try to hide the mapbox feature
    this.getMap().setFeatureState({ source: this.selectedFeature.source, id: this.selectedFeature.id }, { disabled: true })
  }

  async update (data) {
    switch (data) {
      case 'save':
        this.changeDialog = false
        this.mapHelper.onToolSave(this.selectedFeature.id, JSON.stringify(this.draw.getAll().features[0].geometry))
        break
      case 'delete':
        if (this.draw.getAll().features.length === 0 || this.draw.getAll().features[0].geometry.coordinates[0].length < 5) {
          if (this.draw.getAll().features.length > 0) {
            return this.mapHelper.onToolError('Es müssen mindestens 3 Punkte verbleiben')
          }
          return
        }
        return this.draw.trash()
      case 'deselect':
        this.changeDialog = false
        if (this.selectedFeature) {
          this.getMap().setFeatureState({ source: this.selectedFeature.source, id: this.selectedFeature.id }, { disabled: false })
          this.selectedFeatureId = null
        }

        this.mapHelper.onToolInfo('')
        this.draw.deleteAll()
        this.mode = 'select'
        break
      case 'select':
      default:
        if (this.changeDialog) {
          let result = await this.showChangeDialog()
          if (!result) {
            return
          }
          this.changeDialog = false
        }
        if (this.selectedFeature) {
          this.getMap().setFeatureState({ source: this.selectedFeature.source, id: this.selectedFeature.id }, { disabled: false })
          this.selectedFeatureId = null
        }
        this.mapHelper.onToolInfo('')
        this.draw.deleteAll()
        this.mode = 'select'
    }
  }

  async showChangeDialog () {
    let result = await this.mapHelper.$dialog.open({
      title: 'Objekt wechseln',
      message: 'Wollen Sie wirklich das Objekt wechseln?<br/>Alle bestehenden Änderungen gehen dabei verloren'
    })

    if (!result || !result.confirmed) {
      return false
    }

    return true
  }

  updateToolInfo (geom) {
    this.mapHelper.onToolInfo(Math.round(area(geom) * 100) / 100 + ' m²')
  }

  destroy () {
    if (this.selectedFeature) {
      this.getMap().setFeatureState({ source: this.selectedFeature.source, id: this.selectedFeature.id }, { disabled: false })
    }
    this.getMap().removeControl(this.draw)
    // this.getMap().off('draw.create', this.drawCreate)
    this.getMap().off('draw.update', this.drawUpdate)
    // this.getMap().off('draw.delete', this.drawDelete)
    // this.getMap().off('draw.modechange', this.drawModeChange)
  }

  drawCreate = (e) => {
  }

  drawUpdate = (e) => {
    this.changeDialog = true
    this.updateToolInfo(e.features[0].geometry)
  }

  drawDelete = (e) => {
    // we can't delete in this mode
    /* console.log('draw.delete', this.lastStateBeforeTrash, this.draw)
    this.updateToolInfo(this.lastStateBeforeTrash.geometry)
    this.draw.changeMode('draw_polygon')
    let featureIds = this.draw.add(this.lastStateBeforeTrash)
    console.log('new added feature', featureIds)
    this.draw.changeMode('direct_select', { featureId: featureIds[0] })
    console.log('all features', this.draw.getAll()) */
  }

  drawModeChange = (e) => {
  }
}

export default Draw
